import { defineComponent, openBlock, createElementBlock, createElementVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "SjDesignServices1"
});
const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M14.7564 20.8702C14.5781 20.7333 14.408 20.5842 14.2474 20.4236C13.273 19.4492 12.7256 18.1277 12.7256 16.7497C12.7256 15.3717 13.273 14.0501 14.2474 13.0757C15.2218 12.1014 16.5433 11.554 17.9213 11.554C18.5375 11.554 19.1424 11.6634 19.7101 11.8716V10.3637V5.56366V3.72751C19.7101 3.17522 19.2623 2.72729 18.7101 2.72729H5.29004C4.73775 2.72729 4.29004 3.17484 4.29004 3.72713L4.29006 7.36366V19.8702C4.29006 20.4225 4.73769 20.8702 5.28997 20.8702H8.9264H14.7564ZM7.63635 6.5C7.63635 6.22386 7.86021 6 8.13635 6H15.8636C16.1398 6 16.3636 6.22386 16.3636 6.5V7.13636C16.3636 7.41251 16.1398 7.63636 15.8636 7.63636H8.13635C7.86021 7.63636 7.63635 7.41251 7.63635 7.13636V6.5ZM8.13635 9.81818C7.86021 9.81818 7.63635 10.042 7.63635 10.3182V10.9545C7.63635 11.2307 7.86021 11.4545 8.13635 11.4545H13.3868C13.663 11.4545 13.8868 11.2307 13.8868 10.9545V10.3182C13.8868 10.042 13.663 9.81818 13.3868 9.81818H8.13635ZM7.63635 13.5909C7.63635 13.3148 7.86021 13.0909 8.13635 13.0909H11.5C11.7761 13.0909 12 13.3148 12 13.5909V14.2273C12 14.5034 11.7761 14.7273 11.5 14.7273H8.13635C7.86021 14.7273 7.63635 14.5034 7.63635 14.2273V13.5909Z",
  fill: "white"
}, null, -1);
const _hoisted_3 = /* @__PURE__ */ createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M15.0594 19.6115C14.3004 18.8525 13.874 17.8231 13.874 16.7497C13.874 15.6763 14.3004 14.6468 15.0594 13.8878C15.8185 13.1288 16.8479 12.7024 17.9213 12.7024C18.9947 12.7024 20.0241 13.1288 20.7831 13.8878C21.5422 14.6468 21.9686 15.6763 21.9686 16.7497C21.9686 17.8231 21.5422 18.8525 20.7831 19.6115C20.0241 20.3705 18.9947 20.7969 17.9213 20.7969C16.8479 20.7969 15.8185 20.3705 15.0594 19.6115ZM17.4092 18C17.133 18 16.9092 17.7762 16.9092 17.5V15.2273C16.9092 14.9512 17.133 14.7273 17.4092 14.7273H17.8798C18.1559 14.7273 18.3798 14.9512 18.3798 15.2273V16.5386H19.6819C19.958 16.5386 20.1819 16.7625 20.1819 17.0386V17.4999C20.1819 17.7761 19.9581 17.9999 19.6819 17.9999L17.4092 18Z",
  fill: "white",
  "fill-opacity": "0.67"
}, null, -1);
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_4);
}
var SJ__Design_Services_1 = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

export { SJ__Design_Services_1 as default };
